import 'core-js';
import './index.module.scss';

import React from 'react';
import ReactDOM from 'react-dom';
import { configure } from 'mobx';
import vConsole from 'vconsole';

import App from '@shared/App';
import * as serviceWorker from './serviceWorker';

// if (process.env.NODE_ENV === 'development') {
new vConsole({
    onReady: () => {
        const dom = document.getElementById('__vconsole');
        if (dom) {
            dom.classList.add('txr-ignore');
            dom.classList.add('txr-block');
        }
    }
});
// }

configure({ enforceActions: 'observed' });

ReactDOM.render(<App />, document.getElementById('root'));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
